export default {
  data () {
    return {
      staticComponentId: null
    }
  },
  methods: {
    disableEventBus () {
      for(var key in this.events) {
        if (Object.hasOwnProperty.call(this.events, key)) {
          this.EventBus.$off(key, this.events[key])
        }
      }
    },
    enableEventBus () {
      for(var key in this.events) {
        if (Object.hasOwnProperty.call(this.events, key)) {
          this.EventBus.$on(key, this.events[key])
        }
      }
      if (this.events && this.events.restoreDetails) {
        this.EventBus.$emit('detailsHostReady', { shopId: this.shopId })
      }
    }
  },
  computed: {
    events: {
      get () {
        return this.$store.state.events[this.staticComponentId]
      },
      set (data) {
        if (data) {
          this.$store.commit('setEvent', { identifier: this.staticComponentId, handler: data })
        } else {
          this.$store.commit('setEvent', { identifier: this.staticComponentId, handler: null })
        }
      }
    },
    myComponentId () {
      return this.column ? this.column.identifier + '-' + this.column.component.id : null
    }
  },
  mounted () {
    this.staticComponentId = '' + this.myComponentId
    /*
    // Probably not needed after all
    if (import.meta.hot) {
      import.meta.hot.dispose(() => {
        this.disableEventBus()
      })
    }
    */
  },
  beforeUnmount () {
    this.disableEventBus()
    this.events = null
  }
}